const FALLBACK_REDIRECT = "/consortium";
const INTERNAL_ORIGIN = "https://catasto.local";

export const sanitizeAuthRedirect = (value: string | undefined): string => {
  if (!value || !value.startsWith("/") || value.startsWith("//") || value.includes("\\")) {
    return FALLBACK_REDIRECT;
  }

  try {
    const url = new URL(value, INTERNAL_ORIGIN);
    const decodedPathname = decodeURIComponent(url.pathname);

    if (
      url.origin !== INTERNAL_ORIGIN ||
      decodedPathname.includes("\\") ||
      url.pathname === "/login"
    ) {
      return FALLBACK_REDIRECT;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return FALLBACK_REDIRECT;
  }
};
